import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/payment-management/customer-payment-logs')({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
